
















import { Vue, Component, PropSync, Prop, Emit } from "vue-property-decorator";
@Component({
  name: "AgroOnOff",
})
export default class AgroOnOff extends Vue {
  @PropSync("onOff", { type: Boolean, default: false })
  private enabled!: boolean;

  @Prop({ type: String, default: "" }) private label!: string;
  @Prop({ type: String, default: "#10966b" }) private color!: string;
  @Prop({ type: String, default: "uppercase" }) private textTranform!: string;
  
  @Prop({ type: String}) private id!: string;



  private toggle(event: any) {
    this.$emit("toggled", event);
  }
}
